import { useRef, useState, useEffect } from "react";
import { Swiper as SwiperClass } from "swiper";


/*  This helper component is built for a special case/issue: 

    To temporarily deactivate Swiper JS components while the nav menu is open.
    This is to allow a users to click on a Swiper JS component and still have the nav close.
    The issue is caused due to Swiper preventing clicks (event propagation) on it's components for UI navigation reasons.
    The issue isn't resolved with using Swiper's options 'preventClicks' and 'preventClicksPropagation' props.
    Therefore, a manual approach needs to be taken.
*/

const enableSwiperClicksFromNav = () => {
  const swiperRef = useRef<SwiperClass | null>(null);
  const [isNavDrawerOpen, setIsNavDrawerOpen] = useState(false);
  const navDrawer = document.querySelector(".menu-dropdown-drawer");

  // handle pull the nav drawer state
  const checkDrawerState = () => {
    if (navDrawer) {
      const style = window.getComputedStyle(navDrawer);
      setIsNavDrawerOpen(style.display !== "none");
    }
  };

  useEffect(() => {
    const swiper = swiperRef.current;
    // if nav is open, disable swiper
    if (isNavDrawerOpen && swiper) {
      swiper.disable();
    }

    // if nav is closed, enable swiper again
    else if (swiper) {
      swiper.enable();
    }
  }, [isNavDrawerOpen]);

  useEffect(() => {
    const observer = new MutationObserver(checkDrawerState);
    if (navDrawer) {
      observer.observe(navDrawer, { attributes: true });
    }
    return () => observer.disconnect();
  }, []);

  return { swiperRef, isNavDrawerOpen, checkDrawerState }
}

export default enableSwiperClicksFromNav;